import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IncentivesElectricEntities } from 'client/data/models/incentives-electric';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { IncentiveBadge } from 'site-modules/shared/components/incentives/incentive-badge/incentive-badge';
import { IncentivesModalItem } from 'site-modules/shared/components/incentives/incentives-modal-item/incentives-modal-item';
import { getRebateAmount } from 'site-modules/shared/utils/incentives/get-rebate-amount-from-incentives';

import './incentives-modal-data.scss';

export function IncentivesModalData({
  modalData: {
    programType,
    description,
    grantor,
    endDate,
    updateDate,
    restrictions,
    subtype,
    rebateAmount: rebateAmountDefault,
    sessionId,
    id,
    rebateOverridesByEligibility,
  } = null,
  eligibleIncentiveIds,
}) {
  const modalParamsData = {
    incentiveId: id,
    sessionId,
    make: '',
    model: '',
  };
  const rebateAmount = getRebateAmount({ rebateOverridesByEligibility, rebateAmount: rebateAmountDefault });
  const isEligible = !!eligibleIncentiveIds && eligibleIncentiveIds.includes(id);

  return (
    <>
      <div className="mb-1 me-1_5">
        <IncentiveBadge programType={programType} rootClassName="mb-0_5" mode="circle" tag="h2">
          <span className="size-24 fw-bold text-cool-gray-10 ms-0_5">{subtype}</span>
        </IncentiveBadge>
        {!!rebateAmount && (
          <h3
            className={classnames('size-24 fw-bold mb-0', {
              'eligible-color': isEligible,
              'text-green-40': !isEligible,
            })}
          >
            {getPriceString(rebateAmount)}
          </h3>
        )}
      </div>

      <div className="overflow-y-auto">
        <IncentivesModalItem
          grantor={grantor}
          endDate={endDate}
          updateDate={updateDate}
          restrictions={restrictions}
          description={description}
          modalParamsData={modalParamsData}
        />
      </div>
    </>
  );
}

IncentivesModalData.propTypes = {
  modalData: IncentivesElectricEntities.IncentiveData,
  eligibleIncentiveIds: PropTypes.arrayOf(PropTypes.string),
};
